import type React from "react"

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <div className="text-lg font-bold">Badkul Technology</div>
            <div className="text-sm text-gray-400">JSON Builder Tool</div>
          </div>

          <div className="text-sm text-gray-400">&copy; {currentYear} Badkul Technology. All rights reserved.</div>
        </div>
      </div>
    </footer>
  )
}
